export enum VisibiliteChantier { Prive = 0, Public = 1 }

// Résultat de la mesure d'efficacité (Non/Oui = anciennes valeurs booléennes 0/1).
export enum Efficacite { Non = 0, Oui = 1, EnCours = 2 }

export interface ShortUtilisateur { id: string; nom?: string; prenom?: string; nomComplet?: string; photo?: string; }

export interface ChantierStatut { id: number; valeur: string; couleur: string; resolu: boolean; defaut?: boolean; }

export interface ChantierPriorite { id: number; valeur: string; couleur: string; defaut?: boolean; }

export interface ChantierListItem {
  id: string; nom: string;
  categorieLibelle: string; categorieCouleur: string; origineLibelle: string;
  sousCategorie?: string; visibilite: VisibiliteChantier; statut: number; priorite?: number;
  dateEcheance?: string; isCloture: boolean;
  archivedAt?: string;
  created: string;
  nbParticipants: number; nbPlansAction: number;
  // Projet d'amélioration continue de rattachement (null si non rattaché).
  projetId?: string; projetNom?: string;
}

export interface Lien { id?: string; libelle: string; url: string; }
export interface FichierPlanAction { id: string; nom: string; libelle?: string; }
// dateHeure : jour seul ('YYYY-MM-DD' à l'écriture), l'heure n'est plus saisie.
export interface ReunionPlanifiee { id?: string; libelle: string; dateHeure: string; invites: ShortUtilisateur[]; }

export interface PlanAction {
  id: string; chantierId: string; libelle: string; description?: string; statut: number; dateEcheance?: string;
  responsable: ShortUtilisateur; processusId?: string; processusNom?: string;
  liens: Lien[]; fichiers: FichierPlanAction[]; reunionsPlanifiees: ReunionPlanifiee[];
}

// Mesure d'efficacité (1:0..1 portée par le chantier ; null si non renseignée côté serveur).
export interface MesureEfficacite { dateMesure: string; indicateurs: string; estEfficace: Efficacite; actionsAmelioration?: string; }
// Référence légère vers un chantier (parent ou enfant) pour l'affichage.
export interface ChantierRef { id: string; nom: string; statut: number; }

export interface ChantierDetail {
  id: string; nom: string; description?: string; notes?: string;
  categorieId: string; categorieLibelle: string; categorieCouleur: string;
  origineId: string; origineLibelle: string; sousCategorie?: string;
  visibilite: VisibiliteChantier; statut: number; priorite?: number;
  dateDebut?: string; dateEcheance?: string;
  isCloture: boolean; dateCloture?: string; archivedAt?: string; livrables?: string;
  responsableId?: string; responsable?: ShortUtilisateur;
  participantIds: string[]; participants: ShortUtilisateur[]; plansAction: PlanAction[];
  mesureEfficacite?: MesureEfficacite;
  chantierParentId?: string; parent?: ChantierRef; enfants: ChantierRef[];
  // Projet d'amélioration continue de rattachement (null si non rattaché).
  projetId?: string; projetNom?: string;
  userIsParticipant: boolean; userCanManage: boolean; userCanSeeInternal: boolean;
  userCanManageParticipants: boolean;
}

export interface NoteListItem {
  id: string; planActionId: string; reunionPlanifieeId?: string;
  date: string; titre: string; aRedactionInterne: boolean;
  compteRenduPublic?: string; aRedigeCompteRenduPublic: boolean;
}

export interface NoteDetail {
  id: string; planActionId: string; chantierId: string; reunionPlanifieeId?: string;
  date: string; titre: string; notesInternesHtml?: string; compteRenduPublic?: string;
}

export interface CategorieChantier { id: string; libelle: string; couleur: string; }
export interface OrigineChantier { id: string; libelle: string; }
export interface ProcessusChantier { id: string; libelle: string; }

// Write models
export interface CreateChantierModel {
  nom: string; description?: string; categorieId: string; origineId: string;
  sousCategorie?: string; visibilite: VisibiliteChantier; dateEcheance?: string; participantIds: string[];
  responsableId: string; dateDebut?: string; livrables?: string; priorite?: number;
  chantierParentId?: string; ficheIncidentId?: string;
  // Rattachement optionnel à un projet d'amélioration continue.
  projetId?: string;
}
export interface UpdateChantierModel extends CreateChantierModel { statut: number; dateCloture?: string; }

export interface MesureEfficaciteWrite { dateMesure: string; indicateurs: string; estEfficace: Efficacite; actionsAmelioration?: string; }

export interface LienWrite { id?: string; libelle: string; url: string; }
export interface ReunionWrite { id?: string; libelle: string; dateHeure: string; inviteIds: string[]; }
export interface AddPlanActionModel { libelle: string; description?: string; responsableId: string; processusId?: string; dateEcheance?: string; }
export interface UpdatePlanActionModel extends AddPlanActionModel { statut: number; liens: LienWrite[]; reunions: ReunionWrite[]; }

export interface CreateNoteModel { reunionPlanifieeId?: string; date: string; titre: string; notesInternesHtml?: string; compteRenduPublic?: string; }
export interface UpdateNoteModel extends CreateNoteModel {}

// Récap chantiers publics (tableau de bord kanban) — champs EXACTEMENT renvoyés par ChantierRecapItemDto.
// Pas d'héritage de ChantierListItem : l'API n'envoie ni `created` ni `archivedAt` pour le récap.
export interface ChantierRecapItem {
  id: string; nom: string;
  categorieLibelle: string; categorieCouleur: string; origineLibelle: string;
  sousCategorie?: string; visibilite: VisibiliteChantier; statut: number; priorite: number;
  dateEcheance?: string; isCloture: boolean;
  nbParticipants: number; nbPlansAction: number;
  dateStatutActuel?: string;
  dateClotureEffective?: string;
}
export interface ChantierRecapColumn {
  statutId: number; libelle: string; couleur: string;
  estTerminal: boolean; total: number; items: ChantierRecapItem[];
}
export interface ChantierRecapBoard {
  colonnes: ChantierRecapColumn[];
}

// Bulletin de synthèse (document reveal.js auto-généré par IA)
export interface ChantierBulletin {
  html: string;
  generatedAt: string;
  periodeLibelle: string;
  nbChantiers: number;
}
